import { useState, useEffect } from 'react';
import { resolveExplainer } from './explainers';

/**
 * ExplainerToggle · the one sanctioned explanation affordance (handoffV5 §11.4
 * / §12.3). Default OFF — the working surface stays clean per §11. When on, a
 * panel slides in explaining the current view: purpose / how to read / owner /
 * how to act. State remembered per browser.
 */
export default function ExplainerToggle({ view, engineId }: { view: string; engineId?: number }) {
  const [open, setOpen] = useState(false);

  // Remember the toggle's preference across views/sessions.
  useEffect(() => {
    setOpen(localStorage.getItem('c2.explainer.open') === '1');
  }, []);
  function toggle() {
    setOpen((o) => {
      localStorage.setItem('c2.explainer.open', o ? '0' : '1');
      return !o;
    });
  }

  const ex = resolveExplainer(view, engineId);

  return (
    <>
      <button
        type="button"
        className="btn-icon"
        onClick={toggle}
        aria-label="What is this view?"
        title="What is this view?"
        style={{ borderColor: open ? 'var(--amber)' : undefined, color: open ? 'var(--amber)' : undefined }}
      >
        ?
      </button>
      {open && (
        <div
          role="complementary"
          style={{
            position: 'fixed', top: 0, right: 0, bottom: 0, width: 360, zIndex: 50,
            background: 'var(--panel)', borderLeft: '1px solid var(--line)',
            boxShadow: '-12px 0 32px rgba(0,0,0,0.28)', padding: '20px 22px', overflowY: 'auto',
          }}
        >
          <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <span style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--amber)' }}>What is this</span>
            <button type="button" className="btn-icon" onClick={toggle} aria-label="Close" title="Close">✕</button>
          </div>
          <ExplainerSection label="Purpose" body={ex.purpose} />
          <ExplainerSection label="What the data means" body={ex.dataMeaning} />
          <ExplainerSection label="Who owns it" body={ex.owner} />
          <ExplainerSection label="How to act" body={ex.howToAct} />
          <div className="small faint" style={{ marginTop: 18, fontSize: 11 }}>
            This panel is the only place the surface explains itself. Toggle it off and the working view stays clean.
          </div>
        </div>
      )}
    </>
  );
}

function ExplainerSection({ label, body }: { label: string; body: string }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div className="small faint" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 5 }}>{label}</div>
      <div style={{ fontSize: 14, lineHeight: 1.55, color: 'var(--ink)' }}>{body}</div>
    </div>
  );
}
